<div>
  @if (superSearchTabs) {
    <div class="super-search-tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="super-search-tab"
        [class.active]="activeTab === 'order'"
        [attr.aria-selected]="activeTab === 'order'"
        (click)="switchTab('order')">
        Orders
        @if (tabState.order.loaded) {
          <span class="super-search-tab-count">{{ tabState.order.rowCount }}</span>
        }
      </button>
      <button
        type="button"
        role="tab"
        class="super-search-tab"
        [class.active]="activeTab === 'carrier'"
        [attr.aria-selected]="activeTab === 'carrier'"
        (click)="switchTab('carrier')">
        Carriers
        @if (tabState.carrier.loaded) {
          <span class="super-search-tab-count">{{ tabState.carrier.rowCount }}</span>
        }
      </button>
    </div>
  }
  @if(isDataLoaded) {
    <div class="ui-fluid">
      <p-table #dt
              [value]="model.rows"
              [globalFilterFields]="filterableColumnKeys"
              selectionMode="single"
              [loading]="isLoading"
              [loadingIcon]="null"
              [showLoader]="false"
              [lazy]="true"
              sortMode="multiple"
              [multiSortMeta]="multiSortMeta"
              (onLazyLoad)="lazyLoad($event)"
              [paginator]="false"
              [rows]="rows"
              [totalRecords]="rowCount"
              (onRowSelect)="rowChangePreview($event.data.guid)"
              class="table-layout-fixed">
        <ng-template pTemplate="header">
          <tr class="order-list-header" [class.super-search-header]="superSearchTabs">
            <th id="search-list-width" class="order-list-width" [ngClass]="{
              'accounting-list-width': entityName === 'invoice',
              'user-search-list': entityName === 'user'
            }" [class.location-width]="entityName === 'location'" [attr.width]="rowTools.width" [style.min-width]="rowTools.width"></th>
            <th id="search-list-sortable" *ngFor="let col of visibleColumns" [pSortableColumn]="col.sortable ? col.key : null" [style.width.px]="col.width" [style.min-width.px]="col.width">
              <table>
                <tbody>
                  <th id="search-list-name" class="th-display-none"></th>
                  <tr>
                    <td style="width:22px">
                      <p-sortIconCustom *ngIf="col.sortable === true" [field]="col.key"></p-sortIconCustom>
                    </td>
                    <td>
                      {{col.name}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody" let-columns>
          <tr>
            <td [attr.colspan]="numColumns" style="text-align: center">
              Loading...
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="numColumns" style="text-align: center">
              No records found
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
          <tr [pSelectableRow]="item" (mouseenter)="hover = item.id" (mouseleave)="hover = null" [style.background-color]="rowColor(item)">
            <td class="overflow-hidden">
              <row-tools [tools]="rowToolsArr[i]" [item]="item" [class]="item.colourCode ? 'link-btn' : 'table-order-number'" [entityName]="entityName" (onSetRowColour)="setRowColour($event)" (onClick)="clickRowTools($event)"  [visible]="hover == item.id" [noColor]="item.carrierStatus!=2 && item.carrierStatus!=null ? false: true"></row-tools>
            </td>
            <td *ngFor="let col of visibleColumns" [style.background-color]="getColumnStyle(col, item)" [style.color]="getColumnTextColor(col, item)">
              <dynamic-value [data]="item" [class]="col.key == 'number' && item.colourCode ? 'link-btn' : 'table-order-number'" [column]="col"></dynamic-value>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <paginator-custom [rows]="dt.rows" [totalRecords]="dt.totalRecords" (onPageChange)="lazyLoad($event)"></paginator-custom>
    </div>
  } @else {
    <div class="weeklyreport-nodata">
      <div class="no-data-content">
        @if (!isDataLoaded) {
        <img src="./assets/images/alert.svg" alt="alert-icon" class="alert-icon">
        <p class="nodata-text" >Please select filter(s) and click on Search </p>
        } @else {
          <p class="nodata-text" >No records found </p>
        }
       
      </div>
    </div>
  }
</div>
<p-dialog [(visible)]="showUserModal"
          [style]="{width: '100vw',padding:'0 15px',border:'none',maxHeight:'100%'}"
          [modal]="true"
          [showHeader]="false"
          [closable]="false">
  <user-form *ngIf="showUserModal"
             [id]="selection?.guid"
             (onCancel)="cancel()"
             (onSaveComplete)="onUserSaveComplete($event)"></user-form>
</p-dialog>
<p-dialog  #orderDialog
          [(visible)]="showOrderModal"
          styleClass="order-form-width p-dialog-width-bulkupload bulk-upload-window"
          [modal]="true"
          [showHeader]="false"
          [closable]="false"
          appendTo="body">
  <order-form *ngIf="showOrderModal"
              [dialog]="dialogRef"
              [id]="entityName == 'invoice' ? invoiceOrderNumber : selection?.guid"
              (onCancel)="cancel($event)"
              (onSaveComplete)="save($event);"
              (onRevert)="revert($event)"
              [navigateOnSave]="false" class="order-form-alignment"></order-form>
</p-dialog>

<p-dialog #locationDialog [(visible)]="showLocationModal" [style]="{width: '100vw',padding:'15px',border:'none',maxHeight:'100%', boxShadow:'none'}" [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
  <location-form *ngIf="showLocationModal" [id]="selection?.guid" (onCancel)="cancel()" (onSaveComplete)="save($event);"></location-form>
</p-dialog>
<p-dialog [(visible)]="isDeleting" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false" [closable]="false">
  <div class="modal-body-custom">
    Are you sure you want to delete {{selection?.fullName}}?
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7" (click)="cancelDelete()">Cancel</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="submit" (click)="delete(entityName)">Delete</button>
      </div>
    </div>
  </div>
</p-dialog>
